import { useCallback, useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { useEventListener } from 'hooks'
import { dispatch } from 'store'
import { aiImageThunks } from 'store/features/aiImage/thunks'
import { aiImageSelectors } from 'store/features/aiImage/selectors'

import { HISTORY_FETCH_LIMIT } from '../consts'
import { getIsScrollAtBottom } from './utils'

interface IUseFetchAiImageHistoryDataOnScrollProps {
  containerRef: HTMLElement | null
}

export const useFetchAiImgHistoryDataOnScroll = ({
  containerRef
}: IUseFetchAiImageHistoryDataOnScrollProps) => {
  const historyItems = useSelector(aiImageSelectors.historyData)
  const totalHistoryCount = useSelector(aiImageSelectors.totalHistoryCount) || 0
  const [offset, setOffset] = useState<number | null>(null)

  const handleScroll = useCallback(() => {
    const isScrollAtBottom = getIsScrollAtBottom(containerRef)

    if (isScrollAtBottom) {
      setOffset(historyItems?.length || 0)
    }
  }, [containerRef, historyItems])

  useEventListener('scroll', handleScroll, containerRef)

  useEffect(() => {
    const isOffsetValid = offset && offset < (totalHistoryCount || 0)

    if (isOffsetValid) {
      dispatch(
        aiImageThunks.getHistory({
          offset,
          limit: HISTORY_FETCH_LIMIT
        })
      )
    }
  }, [offset, totalHistoryCount])
}
